import posters from './coursePosters.json';
import { AdmCover } from './AdmPreparation';

export default function CourseCover({ contest, className = '', priority = false }) {
  const poster = posters[contest?.contest_id];
  if (!poster) return <AdmCover contest={contest} className={className} />;
  return <img src={poster.src} alt={poster.alt} width="1200" height="720"
    loading={priority ? 'eager' : 'lazy'} decoding="async"
    className={`block h-auto w-full ${className}`} data-testid={`course-cover-${contest.contest_id}`} />;
}
